{
  "actions": {
    "new": "New supplier",
    "archive": "Archive",
    "restore": "Restore",
    "newPurchase": "New purchase",
    "pay": "Pay supplier",
    "newReturn": "New return or allowance",
    "refund": "Record refund",
    "credit": "Unapplied credit and refunds",
    "printStatement": "Print statement",
    "retryFigures": "Load the balance again",
    "open": "Open",
    "statement": "Statement",
    "rowActions": "Actions for {{name}}",
    "export": "Export view"
  },
  "fields": {
    "code": "Code",
    "name": "Name",
    "nameAr": "Name in Arabic",
    "company": "Company",
    "contactPerson": "Contact person",
    "mobile": "Mobile",
    "phone": "Phone",
    "email": "Email",
    "address": "Address",
    "city": "City",
    "country": "Country",
    "status": "Status",
    "groups": "Groups",
    "taxNumber": "Tax number",
    "notes": "Notes",
    "bankName": "Bank",
    "bankAccountName": "Account name",
    "bankAccountNumber": "Account number",
    "bankIban": "IBAN",
    "bankSwift": "SWIFT / BIC",
    "createdAt": "Created",
    "updatedAt": "Last changed",
    "balance": "Balance",
    "overdue": "Overdue",
    "unallocatedCredit": "Unapplied credit"
  },
  "status": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "ARCHIVED": "Archived"
  },
  "list": {
    "title": "Suppliers",
    "tableLabel": "Suppliers",
    "views": "Supplier views",
    "view": {
      "current": "All",
      "active": "Active",
      "inactive": "Inactive",
      "archived": "Archived"
    },
    "searchLabel": "Search suppliers",
    "searchPlaceholder": "Search name, code, mobile…",
    "clearSearch": "Clear search",
    "groupFilter": "Filter by group",
    "allGroups": "All groups",
    "clearFilters": "Clear filters",
    "empty": {
      "title": "No suppliers yet.",
      "body": "Add your first supplier to record purchases and expenses against it.",
      "filteredTitle": "No suppliers match.",
      "filteredBody": "Try another name, code or mobile number, or clear the filters.",
      "view": {
        "current": "No suppliers yet.",
        "active": "No active suppliers.",
        "inactive": "No inactive suppliers.",
        "archived": "No archived suppliers."
      },
      "balance": {
        "owes": "We owe no supplier anything.",
        "overdue": "Nothing is overdue.",
        "credit": "We hold no credit with any supplier."
      }
    },
    "overdueMarker": "Part of it is overdue",
    "creditHeld": "Credit held: the supplier owes us {{amount}}",
    "exportHint_one": "CSV of the {{n}} supplier in this view",
    "exportHint_other": "CSV of the {{n}} suppliers in this view",
    "balanceView": {
      "owes": "We owe",
      "overdue": "Overdue",
      "credit": "Credit held"
    },
    "stats": {
      "label": "Supplier figures",
      "active": "Active suppliers",
      "ofAll": "of {{total}}",
      "activeShare": "{{percent}}% of the suppliers are active",
      "owed": "We owe",
      "owedDetail": "to {{suppliers}}",
      "overdueShare": "{{percent}}% of what we owe is overdue",
      "overdue": "Overdue",
      "credit": "Credit held",
      "unavailable": "Figures unavailable",
      "suppliers_one": "{{n}} supplier",
      "suppliers_other": "{{n}} suppliers"
    }
  },
  "detail": {
    "record": "Record",
    "noBank": "No bank details.",
    "noBankHint": "No bank details yet. Edit the supplier to add them before paying by transfer."
  },
  "new": {
    "title": "New supplier",
    "subtitle": "The supplier code is assigned when you save."
  },
  "edit": {
    "title": "Edit {{name}}",
    "subtitle": "Edit supplier",
    "archivedTitle": "This supplier is archived",
    "backToSupplier": "Back to supplier"
  },
  "form": {
    "save": "Save supplier",
    "saveHint": "Press {{shortcut}} to save",
    "sections": {
      "identity": "Identity",
      "contact": "Contact",
      "address": "Address",
      "bank": "Bank details",
      "classification": "Classification",
      "taxNotes": "Tax and notes"
    },
    "hints": {
      "company": "The legal or trading name, if different from the supplier's name.",
      "groupsUnavailable": "Groups couldn't be loaded. You can add them later.",
      "bank": "Where payments to this supplier go.",
      "iban": "Omani IBANs start with OM and have 23 characters."
    },
    "groupsPlaceholder": "Choose groups",
    "groupsSearch": "Search groups…",
    "groupsEmpty": "No groups found.",
    "groupsClear": "Clear selection",
    "groupsSelected": "{{n}} groups",
    "errors": {
      "title": "The supplier wasn't saved",
      "mobileTaken": "This mobile number is already used by another supplier.",
      "taxNumberTaken": "This tax number is already used by another active supplier.",
      "archived": "Restore this supplier before editing it."
    },
    "conflict": {
      "title": "Someone else changed this supplier",
      "body": "Your changes weren't saved. Reload to see the latest version, then make your changes again.",
      "reload": "Reload latest"
    },
    "leave": {
      "title": "Discard unsaved changes?",
      "body": "You have changes on this page that haven't been saved.",
      "confirm": "Discard changes",
      "cancel": "Keep editing"
    }
  },
  "archive": {
    "title": "Archive {{name}}?",
    "body": "Archived suppliers are hidden from lists and can't be used on new documents. You can restore them at any time.",
    "restoreTitle": "Restore {{name}}?",
    "restoreBody": "The supplier returns to lists and can be used on new documents again."
  },
  "toast": {
    "created": "Supplier {{code}} created",
    "updated": "Supplier saved",
    "archived": "Supplier archived",
    "restored": "Supplier restored",
    "exported_one": "{{n}} supplier exported",
    "exported_other": "{{n}} suppliers exported",
    "exportedView": "The view was exported"
  },
  "groups": {
    "title": "Supplier groups",
    "subtitle": "Group suppliers for reports and filters.",
    "new": "New group",
    "newTitle": "New supplier group",
    "newSubtitle": "Name the group in one or both languages.",
    "editTitle": "Edit supplier group",
    "save": "Save group",
    "actions": "Actions",
    "editNamed": "Edit {{name}}",
    "deleteNamed": "Delete {{name}}",
    "showMembers": "Show suppliers in {{name}}",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "description": "Description",
      "members": "Suppliers"
    },
    "empty": {
      "title": "No supplier groups yet.",
      "body": "Create groups such as Local or Overseas to filter and report on suppliers."
    },
    "errors": {
      "nameTaken": "A group with this name already exists.",
      "conflict": "Someone else changed this group while you were editing it. Close the panel and open the group again to see their change."
    },
    "delete": {
      "title": "Delete {{name}}?",
      "body_one": "The group is removed from its {{n}} supplier. The supplier itself is kept.",
      "body_other": "The group is removed from its {{n}} suppliers. The suppliers themselves are kept.",
      "confirm": "Delete group"
    },
    "toast": {
      "created": "Group created",
      "updated": "Group saved",
      "deleted": "Group deleted"
    }
  },
  "errors": {
    "SUPPLIER_HAS_BALANCE": "We still owe this supplier money or hold credit with them. Settle the balance and apply or recover the credit, then archive.",
    "SUPPLIER_HAS_OPEN_CHEQUES": "We have issued cheques to this supplier that the bank has not cleared yet. Archive the supplier once they clear, or after recording a bounce or cancellation.",
    "SUPPLIER_HAS_DRAFTS": "This supplier has draft purchases or returns. Post or delete them, then archive.",
    "GROUP_IN_USE": "Approval workflows route by this group ({{workflows}}). Remove it from their conditions first, then delete it."
  },
  "archiveBlocked": {
    "balance": "Pay the balance of {{amount}} first.",
    "credit": "Recover or apply the credit of {{amount}} first.",
    "openCredit": "Apply the credit of {{amount}} to the open purchases first.",
    "checking": "Checking the balance…",
    "unavailable": "The balance couldn't be loaded."
  },
  "profile": {
    "figures": "Account figures",
    "figuresFailed": "The account figures couldn't be loaded.",
    "balanceOwed": "Balance owed",
    "creditHeld": "Credit held",
    "nothingOwed": "Nothing owed",
    "overdue": "Overdue",
    "oldest": "oldest {{bucket}}",
    "nothingOverdue": "nothing overdue",
    "unappliedCredit": "Unapplied credit",
    "creditSources_one": "on {{count}} document",
    "creditSources_other": "on {{count}} documents",
    "lastPurchase": "Last purchase",
    "lastPayment": "Last payment",
    "none": "None yet",
    "netPurchasesHead": "Net purchases",
    "purchaseCount_one": "{{count}} purchase, ex-VAT",
    "purchaseCount_other": "{{count}} purchases, ex-VAT",
    "aging": "Aging of the balance owed",
    "agingCurrency": "OMR",
    "agingFailed": "The aging couldn't be loaded.",
    "agingUnavailable": "Aging unavailable.",
    "bucket": {
      "current": "Not yet due",
      "days1to30": "1–30",
      "days31to60": "31–60",
      "days61to90": "61–90",
      "over90": "90+"
    },
    "bucketLong": {
      "days1to30": "1–30 days",
      "days31to60": "31–60 days",
      "days61to90": "61–90 days",
      "over90": "over 90 days"
    },
    "tabs": {
      "label": "Supplier sections",
      "overview": "Overview",
      "purchases": "Purchases",
      "payments": "Payments",
      "returns": "Returns",
      "statement": "Statement",
      "tasks": "Tasks",
      "attachments": "Attachments"
    },
    "archivedBanner": "Archived on {{date}}. It can't be used on new documents; its records stay readable.",
    "inactiveBanner": "Inactive: no new purchases. Payments, returns and refunds still work, so old balances can be settled.",
    "showAllNotes": "Show all",
    "attention": {
      "title": "Needs attention",
      "none": "Nothing needs attention.",
      "unavailable": "Unavailable.",
      "overdue_one": "overdue purchase",
      "overdue_other": "overdue purchases",
      "drafts_one": "draft purchase to post",
      "drafts_other": "draft purchases to post",
      "draftReturns_one": "draft return to post",
      "draftReturns_other": "draft returns to post",
      "credit": "Unapplied credit — apply it or have it refunded"
    },
    "recent": {
      "title": "Recent documents",
      "none": "No documents yet."
    },
    "kind": {
      "purchase": "Purchase",
      "payment": "Payment"
    },
    "payTo": {
      "title": "Pay to",
      "copy": "Copy",
      "copied": "Copied",
      "copyNamed": "Copy the {{what}}",
      "copyFailed": "Couldn't copy. Select the text and copy it."
    }
  },
  "docs": {
    "views": {
      "purchases": {
        "label": "Purchase views",
        "all": "All",
        "open": "Open",
        "overdue": "Overdue",
        "drafts": "Drafts",
        "void": "Void"
      },
      "payments": {
        "label": "Payment views",
        "all": "All",
        "withCredit": "Unapplied credit",
        "void": "Void"
      },
      "returns": {
        "label": "Return views",
        "all": "All",
        "withCredit": "Unapplied credit",
        "drafts": "Drafts",
        "void": "Void"
      }
    },
    "empty": {
      "purchases": "No purchases from this supplier yet.",
      "payments": "No payments to this supplier yet.",
      "returns": "No returns or allowances for this supplier yet.",
      "view": "Nothing in this view.",
      "next": {
        "purchases": "Record the supplier's bill when the goods arrive.",
        "payments": "Record a payment when you pay the supplier.",
        "returns": "Send goods back from a purchase, or record a price reduction the supplier gave."
      }
    },
    "rowActions": "Actions for {{number}}"
  },
  "credit": {
    "title": "Unapplied credit",
    "held": "{{amount}} in total",
    "sources": "Documents with unapplied credit",
    "sourcesHint": "Payments with an advance and returns not yet applied to purchases or refunded.",
    "none": "No unapplied credit.",
    "truncated": "Only the newest are listed.",
    "available": "Unapplied",
    "allocate": "Apply",
    "refund": "Refund",
    "refunds": "Refunds received",
    "noRefunds": "No refunds yet.",
    "allRefunds": "All refunds from this supplier",
    "source": {
      "PAYMENT": "Payment",
      "SUPPLIER_RETURN": "Return"
    },
    "applyTo": "Apply {{number}} to purchases",
    "refundFrom": "Refund from {{number}}"
  },
  "picker": {
    "required": "Choose the supplier"
  },
  "quickCreate": {
    "action": "New supplier",
    "actionTyped": "New supplier “{{typed}}”",
    "title": "New supplier",
    "body": "The essentials now; the rest on the supplier’s page.",
    "save": "Add supplier",
    "created": "Supplier {{name}} added",
    "later": "Address, groups, bank details and contact person can be added on the supplier’s page."
  }
}
